document.querySelectorAll('video-media video').forEach(e=> {

    if (e.nodeName == 'VIDEO' && e.getAttribute('muted')) {
        // force autoplay for safari
        e.play();
    }
}) 

window.addEventListener('pplrAddToCartCompleted' , function(e) {
    pplr_w_h();

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    }));

    document.querySelector('[aria-controls="cart-drawer"]')?.click();
})


// Get the paragraph element
const paragraph = document.querySelector('.product-content-below-gallery__description');

// Create a span element for overlay
const overlay = document.createElement('span');
overlay.classList.add('read-more-overlay');
paragraph?.classList.add('clipped')

// Create a link element
const readMoreLink = document.createElement('a');
readMoreLink.href = '#';
readMoreLink.textContent = 'Read more';
readMoreLink.classList.add('read-more');

// Append link to overlay
overlay.appendChild(readMoreLink);

paragraph?.classList.add('clipped')

// Append overlay to paragraph
paragraph?.appendChild(overlay);

// Function to toggle between "Read more" and "Read less"
function toggleReadMore(event) {
  event.preventDefault();

  if (readMoreLink.textContent === 'Read more') {
    paragraph?.classList.add('expanded');
    readMoreLink.textContent = 'Read less';
    paragraph.classList.remove('clipped')
  } else {
    paragraph.classList.remove('expanded');
    readMoreLink.textContent = 'Read more';
    paragraph?.classList.add('clipped')
  }
}

// Add click event listener to the "Read more" link
readMoreLink.addEventListener('click', toggleReadMore);